import React from 'react';
import { CheckboxProps } from 'antd';
import { StyledKccCheckbox } from './KccCheckbox.styles';

// Must be used with KCC theme applied to Ant Design components, otherwise it will not look as intended.
export const KccCheckbox = (props: CheckboxProps): React.JSX.Element => <StyledKccCheckbox {...props} />;
